<div class="flex flex-col gap-6">
  <div class="flex justify-between">
    <!-- TabNavigation -->
    <div class="flex flex-row gap-2">
      <p-button (onClick)="openAvailableApps()" [label]="'App installieren'" [rounded]="true"
      icon="pi pi-plus"></p-button>
      <p-button (onClick)="switchToStore()" [label]="'Zum Store wechseln'" [outlined]="true"
      [rounded]="true"></p-button>
    </div>
  </div>

  <p-table (onLazyLoad)="lazyLoadTable($event)" [lazy]="true" [loading]="(isLoading$ | async) ?? true"
    [paginator]="false"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [rows]="10" [scrollable]="true"
    [showLoader]="false" [tableStyle]="{ 'min-width': '50rem' }" [totalRecords]="(totalRecords$ | async) || 0"
    [value]="(records$ | async) || []">
    <ng-template let-columns="columns" pTemplate="loadingbody">
      @for (i of (skeletonRows$ | async); track i) {
        <tr>
          <td>
            <p-skeleton height="2rem"></p-skeleton>
          </td>
          <td>
            <p-skeleton height="2rem"></p-skeleton>
          </td>
          <td>
            <p-skeleton height="2rem"></p-skeleton>
          </td>
          <td>
            <p-skeleton height="2rem"></p-skeleton>
          </td>
        </tr>
      }
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="8" class="text-center">
          Keine Einträge gefunden
        </td>
      </tr>
    </ng-template>
    <ng-template let-appRecord let-i="rowIndex" pTemplate="body">
      <tr>
        <td>
          <img [src]="appRecord.lightIconUrl" class="rounded" height="48" width="48"/>
        </td>
        <td><strong>{{ appRecord.name }}</strong></td>
        <td>1.0.0</td>
        <td class="flex gap-2 justify-end">
          @if (((totalRecords$ | async) || 0) > 1) {
            <p-button (onClick)="uninstall(appRecord)" [outlined]="true"
              [rounded]="true" icon="pi pi-trash"
              severity="danger"/>
          }
          <p-button [rounded]="true" (onClick)="openAppSettings(appRecord)">Konfigurieren</p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
